import { IMAGE_CONFIG } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PageModule } from './page/page.module';
import { RouterModule } from '@angular/router';
import { AuthInterceptor } from './services/auth.interceptor';
import { MicroempresarioModule } from './microempresario/microempresario.module';
import { MicroempresarioRoutingModule } from './microempresario/microempresario-routing.module';
import { IntermediarioModule } from './intermediario/intermediario.module';
import { IntermediarioRoutingModule } from './intermediario/intermediario-routing.module';
import { DetalleSolicitudComponent } from './comun/components/detalle-solicitud/detalle-solicitud.component';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { BeneficiarioJuridica } from './comun/components/detalle-solicitud/juridica/beneficiario.template';
import { BenficiarioNatural } from './comun/components/detalle-solicitud/natural/beneficiario.template';
import { AlertComponent } from './shared/components/alert/alert.component';
import { ActivarUsuarioComponent } from './core/activar-usuario/activar-usuario.component';
import { RecodardContrasenaComponent } from './core/recordar-contrasena/recordar-contrasena.component';
import { DobleAutenticacionComponent } from './comun/components/doble-autenticacion/doble-autenticacion.component';
import { PreguntasFrecuentesComponent } from './core/preguntas-frecuentes/preguntas-frecuentes.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { LogOutComponent } from './comun/components/log-out/log-out.component';
import { PageMantenimientoModule } from './page-mantenimiento/page-mantenimiento.module';
import { BlogComponent } from './blog/blog.component';
import { ArticulosComponent } from './blog/articulos/articulos.component';
import { NoticiasComponent } from './blog/noticias/noticias.component';
import { DetallePublicacionComponent } from './blog/detalle-publicacion/detalle-publicacion.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from "ng-recaptcha-2";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerModule } from 'ngx-spinner';
import { environment } from 'src/environments/environment';

@NgModule({ declarations: [
        AppComponent,
        DetalleSolicitudComponent,
        BeneficiarioJuridica,
        BenficiarioNatural,
        AlertComponent,
        ActivarUsuarioComponent,
        RecodardContrasenaComponent,
        DobleAutenticacionComponent,
        PreguntasFrecuentesComponent,
        LogOutComponent,
        BlogComponent,
        ArticulosComponent,
        NoticiasComponent,
        DetallePublicacionComponent,
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        PageModule,
        SharedModule,
        CoreModule,
        ReactiveFormsModule,
        NoopAnimationsModule,
        FormsModule,
        RouterModule,
        MicroempresarioModule,
        MicroempresarioRoutingModule,
        IntermediarioModule,
        IntermediarioRoutingModule,
        PageMantenimientoModule,
        NgSelectModule,
        RecaptchaV3Module,
        NgIdleKeepaliveModule.forRoot(),
        NgbTooltipModule,
        NgxSpinnerModule
    ], providers: [
        {
            provide: IMAGE_CONFIG,
            useValue: { disableImageSizeWarning: true },
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: RECAPTCHA_V3_SITE_KEY,
            useValue: environment.tokenReCaptcha,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
